module.exports = __webpack_public_path__ + "static/media/2.4926e315.jpg";